/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Control from '../Control/Control';
import Label from '../Label/Label';
import './Radio.css';

/**
 * Represents the radio component.
 */

export default class Radio extends Control {
    
    /**
     * Properties.
     */

    static propTypes = {
        holder:         PropTypes.object,
        group:          PropTypes.string,
        index:          PropTypes.number,
        checked:        PropTypes.bool,
        disabled:       PropTypes.bool,
        label:          PropTypes.string,
        tooltip:        PropTypes.string,
        onChecked:      PropTypes.func
    }

    /**
     * Default state.
     */

    state = { 
        checked:        this.props.checked
    }

    /**
     * Event that fires when the user clicks to the radio.
     */

    _on = () => {

        // Does the radio enabled?

        if (!this.props.disabled && !this.state.checked) {

            // Setting the new checked state

            this.setValue(true);
           
            // Callbacking the "onChecked" event

            if (this.props.onChecked) {
                this.props.onChecked(this.props.group, this.props.index);
            }
        }
    }
   
    /**
     * Gets the value of the radio.
     * 
     * @return  {Boolean}   checked     checked state of the radio
     */

    getValue = () => {
        return this.state.checked;
    }

    /**
     * Sets the value of the radio.
     * 
     * @param   {Boolean}   value       value of the new checked state
     */

    setValue = (value) => {

        // Setting the state of the radio

        this.setState({ checked: value });

        // Unchecks all of the other radios in the group

        if (value && this.props.holder && this.props.group) {
            let index = 0;

            while (true) {
                let radio = this.props.holder[this.props.group + index];

                if (radio) {
                    if (index !== this.props.index) {
                        radio.setValue(false);
                    }
                } else {
                    break;
                }

                index++;
            }
        }    
    }

    /** 
     * Radio renderer.
     */

    render() {
        return (
            <div className={`${this.props.disabled ? '' : 'radio-container' } horizontal`} style={this._getStyle()} onClick={this._on}>
                <div className={`radio ${this.props.disabled ? 'radio-disabled' : 'radio-enabled' } horizontal vertical center center-justified`} title={this.props.tooltip}>
                    <div className={`radio-checked ${this.props.disabled ? 'radio-checked-disabled' : 'radio-checked-enabled'}`} style={{ opacity: this.state.checked ? 1 : 0 }}></div>
                </div>
                <Label text={this.props.label || ''} disabled={this.props.disabled} leftgap={8} tooltip={this.props.tooltip} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Radio/Radio.js